// Where the customer web app lives. Embed mode is a web-app feature
// (?embed=1&restaurant=<slug>), so links always point at that host.
export const WEB_APP_URL = (process.env.REACT_APP_WEB_APP_URL || 'https://app.rushmyfood.com').replace(/\/+$/, '')

// The restaurant page pinned in embed mode: no site navigation, and every
// other page bounces back to this restaurant.
export const embedUrl = slug => {
  const s = encodeURIComponent(slug)
  return `${WEB_APP_URL}/?embed=1&restaurant=${s}#/restaurant/${s}`
}
